import React from 'react'
import PageUnderConstruction from './PageUnderConstruction'

export default function Photos() {
    return (
        <div data-testid = "photos" className = "component-container">
            Photos 
            <PageUnderConstruction />
        </div>
    )
}
